import {createAction} from "@reduxjs/toolkit";

export const setGuestEvents = createAction('SET_GUEST_EVENTS');